import { useLayoutContext } from "@context/layout";
import CourseIcon from "@svg/header/course";
import Link from "next/link";
import { FC } from "react";
import HeaderSubscriptionButton from "./subscription-button";

interface Props {
  isAccess?: boolean;
}

const MyCourseButton: FC<Props> = ({ isAccess }) => {
  const { userData } = useLayoutContext();

  const isLoggedIn = Boolean(userData?.is_login);
  if (!isLoggedIn) return null;
  return (
    <div className="flex gap-1 items-center">
      {!isAccess && <HeaderSubscriptionButton />}
      <Link
        href="/my-account"
        className="hidden md:flex font-normal flex-nowrap items-center h-10 py-2 px-3 rounded-lg  gap-1 leading-7 whitespace-nowrap  ml-2 text-[#202123] text-sm"
        prefetch={false}
      >
        <CourseIcon />
        آموزش‌های من
      </Link>
    </div>
  );
};

export default MyCourseButton;
